export var OFLOW_COMMAND_CATEGORY;
(function (OFLOW_COMMAND_CATEGORY) {
    OFLOW_COMMAND_CATEGORY["NODE_COMMAND"] = "NODE_COMMAND";
    OFLOW_COMMAND_CATEGORY["EDGE_COMMAND"] = "EDGE_COMMAND";
    OFLOW_COMMAND_CATEGORY["GROUP_COMMAND"] = "GROUP_COMMAND";
    OFLOW_COMMAND_CATEGORY["ADVANCED_COMMAND"] = "ADVANCED_COMMAND";
})(OFLOW_COMMAND_CATEGORY || (OFLOW_COMMAND_CATEGORY = {}));
export const getCommandCategory = (command) => {
    if (/NODES?$/.test(command))
        return OFLOW_COMMAND_CATEGORY.NODE_COMMAND;
    if (/EDGES?$/.test(command))
        return OFLOW_COMMAND_CATEGORY.EDGE_COMMAND;
    if (/GROUPS?$/.test(command))
        return OFLOW_COMMAND_CATEGORY.GROUP_COMMAND;
    if (/ELEMENTS?$/.test(command))
        return OFLOW_COMMAND_CATEGORY.ADVANCED_COMMAND;
};
// edge命令
export var OFlowEdgeCommand;
(function (OFlowEdgeCommand) {
    OFlowEdgeCommand.category = OFLOW_COMMAND_CATEGORY.EDGE_COMMAND;
})(OFlowEdgeCommand || (OFlowEdgeCommand = {}));
// group命令
export var OFlowGroupCommand;
(function (OFlowGroupCommand) {
    OFlowGroupCommand.category = OFLOW_COMMAND_CATEGORY.GROUP_COMMAND;
})(OFlowGroupCommand || (OFlowGroupCommand = {}));
// graph命令
export var OFlowAdvancedCommand;
(function (OFlowAdvancedCommand) {
    OFlowAdvancedCommand.category = OFLOW_COMMAND_CATEGORY.ADVANCED_COMMAND;
})(OFlowAdvancedCommand || (OFlowAdvancedCommand = {}));
//# sourceMappingURL=interface.js.map